export type LogLevel =
  | 'silly'
  | 'trace'
  | 'debug'
  | 'info'
  | 'warn'
  | 'error'
  | 'fatal';

export const LOG_LEVEL_TO_LOG_LEVEL_ID: Record<LogLevel, number> = {
  silly: 0,
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  fatal: 6,
};

export const LOG_LEVELS = Object.keys(
  LOG_LEVEL_TO_LOG_LEVEL_ID,
) as readonly LogLevel[];

export interface Log {
  level: LogLevel;
  levelId: number;
  message: string;
  timestamp: Date;
}
